"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { MoveLeft, MoveRight, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const testimonials = [{
  id: 1,
  author: "William & Catherine",
  role: "Bride & Groom",
  quote: "“A magical experience; the most authentic, vintage memories of our wedding. They captured the essence of our love in a way that digital could never match.”",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562462/img/testimonial_anna_marco.png"
}, {
  id: 2,
  author: "Samuel B.",
  role: "Event Planner",
  quote: "The Italian Minuteros team brought a touch of nostalgia and class to our event. Our guests were fascinated by the daylight development process.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562462/img/testimonial_luigi_b.png"
}, {
  id: 3,
  author: "Oliver & Amelia",
  role: "Bride & Groom",
  quote: "We wanted something unique for our destination wedding in Rome. Vintage Portraits was the highlight of the party, giving everyone a tangible and precious keepsake. The Italian Minuteros team is fantastic!",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562462/img/testimonial_giulia_paolo.png"
}];
export default function VociDalPassatoRecente() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  const handlePrev = () => {
    api?.scrollPrev();
  };
  const handleNext = () => {
    api?.scrollNext();
  };
  return <section id="voci-dal-passato-recente" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 bg-primary/5 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="mb-12 md:mb-20 text-center">
          <h2 className="text-3xl md:text-5xl font-serif font-medium tracking-tight text-primary mb-4">Echoes of a Recent Past</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">Stories from those who chose to stand still with us.</p>
        </div>

        <Carousel setApi={setApi} className="w-full max-w-5xl mx-auto" opts={{
        loop: true,
        align: "center"
      }}>
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={item.id} data-index={i}>
                <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16 p-4 md:p-12">
                  {}
                  <div className="shrink-0 relative group">
                    <div className="absolute inset-0 bg-primary/20 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                    <SafeHydrate><Avatar className="size-32 md:size-48 border-4 border-primary/10 shadow-2xl grayscale">
                      <AvatarImage src={item.image} alt={item.author} className="object-cover" />
                      <AvatarFallback className="text-3xl bg-muted text-muted-foreground">
                        {item.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                  </div>

                  {}
                  <div className="flex flex-col text-center md:text-left relative">
                    <Quote className="absolute -top-8 -left-8 size-12 text-primary/10 rotate-180 hidden md:block" />
                    
                    <blockquote className="font-serif text-2xl md:text-4xl italic leading-relaxed text-foreground/90 mb-6">
                      &ldquo;{item.quote}&rdquo;
                    </blockquote>
                    
                    <div className="mt-auto">
                      <cite className="not-italic font-medium text-lg text-primary block mb-1">
                        {item.author}
                      </cite>
                      <span className="text-sm text-muted-foreground uppercase tracking-widest font-sans">
                        {item.role}
                      </span>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex items-center justify-center md:justify-end gap-4 mt-8 md:mt-0 md:absolute md:bottom-0 md:right-12">
            <Button variant="ghost" size="icon" onClick={handlePrev} className="rounded-full hover:bg-primary/10 hover:text-primary transition-colors" aria-label="Precedente">
              <MoveLeft strokeWidth={1} className="size-8 md:size-10" />
            </Button>
            <div className="font-mono text-sm text-muted-foreground/50 select-none">
              {current.toString().padStart(2, "0")} /{" "}
              {count.toString().padStart(2, "0")}
            </div>
            <Button variant="ghost" size="icon" onClick={handleNext} className="rounded-full hover:bg-primary/10 hover:text-primary transition-colors" aria-label="Successivo">
              <MoveRight strokeWidth={1} className="size-8 md:size-10" />
            </Button>
          </div>
        </Carousel>
      </div>
    </section>;
}